module.exports = __webpack_public_path__ + "img/icon-hit.6189cef1.svg";